import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';

import { ASC, DESC, SORT } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './data-import.reducer';

export const DataImport = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search));

  const dataImportList = useAppSelector(state => state.dataImport.entities);
  const loading = useAppSelector(state => state.dataImport.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    } else {
      return order === ASC ? faSortUp : faSortDown;
    }
  };

  return (
    <div>
      <h2 id="data-import-heading" data-cy="DataImportHeading">
        <Translate contentKey="coconApp.dataImport.home.title">Data Imports</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="coconApp.dataImport.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/data-management/data-import"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="coconApp.dataset.home.import">Import Datasets</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {dataImportList && dataImportList.length > 0 ? (
          <Table striped size="sm" responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="coconApp.dataImport.timestamp">Timestamp</Translate>
                </th>
                <th className="hand" onClick={sort('file')}>
                  <Translate contentKey="coconApp.dataImport.file">File</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('file')} />
                </th>
                <th>Imported by</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {dataImportList.map((dataImport, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>{dataImport.timestamp ? <TextFormat type="date" value={dataImport.timestamp} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{dataImport.file}</td>
                  <td>
                    {dataImport.datasets[0].approvalHistories[0].user.firstName} {dataImport.datasets[0].approvalHistories[0].user.lastName}{' '}
                    ({dataImport.datasets[0].approvalHistories[0].user.login})
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/dataset?dataImportId.equals=${dataImport.id}`}
                        color="primary"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">Show Datasets</span>
                      </Button>
                      <Button tag={Link} to={`/data-import/${dataImport.id}/delete`} color="danger" size="sm" data-cy="entityDeleteButton">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="coconApp.dataImport.home.notFound">No Data Imports found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DataImport;
